import Loadable from 'react-loadable';

export const SearchRedirectAction = Loadable({
  loader: () => import(/* webpackChunkName: "SearchRedirectAction" */ './SearchRedirectAction'),
  loading: () => null,
});
